var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2996 8.22753L13.1431 12.3841L17.265 16.5061C17.6114 16.8178 17.6114 17.3374 17.265 17.6491C16.9533 17.9955 16.4337 17.9955 16.1219 17.6491L11.9654 13.5272L7.84342 17.6491C7.53168 17.9955 7.01211 17.9955 6.70036 17.6491C6.35398 17.3374 6.35398 16.8178 6.70036 16.4714L10.8223 12.3495L6.70036 8.22753C6.35398 7.91579 6.35398 7.39622 6.70036 7.04984C7.01211 6.73809 7.53168 6.73809 7.87806 7.04984L12 11.2064L16.1219 7.08447C16.4337 6.73809 16.9533 6.73809 17.2996 7.08447C17.6114 7.39622 17.6114 7.91579 17.2996 8.22753Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBanner);
export default __webpack_public_path__ + "static/media/close-banner.90769a981c77b12cb96443cb0604c2c0.svg";
export { ForwardRef as ReactComponent };